import React from 'react';

import DateFnsUtils from '@date-io/date-fns';
import { Box, Grid, Typography } from '@material-ui/core';
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import deLocale from 'date-fns/locale/es';

import { ReactComponent as CalendarIcon } from '../../../../assets/img/calendar.svg';
import { ReactComponent as TimeIcon } from '../../../../assets/img/reloj.svg';
import FloatingButton from '../../../../components/FloatingButton';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';

const SelectDate = () => {
  const { nextStep, sinister_body, updateSinisterBody } =
    useSinisterDataContext();
  const [selectedDate, setSelectedDate] = React.useState(
    sinister_body.date || Date.now()
  );
  const maxDate = Date.now();

  const minDate = () => {
    let date = new Date(Date.now());
    date.setDate(date.getDate() - 89);
    return date;
  };

  const callNextStep = () => {
    updateSinisterBody({ date: new Date(selectedDate) });
    nextStep();
  };

  const handleDateChange = (date: any) => {
    if (date > new Date()) {
      setSelectedDate(new Date());
    } else {
      setSelectedDate(date);
    }
  };

  return (
    <Grid container style={{ height: '100%' }}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <Box mr={4}>
          <Box my={4}>
            <Typography
              variant="h3"
              color="textPrimary"
              style={{ fontFamily: 'Inter' }}
            >
              ¿En qué fecha ocurrió?
            </Typography>
          </Box>
          <Box my={4}>
            <Box>
              <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                <Grid item xs={12}>
                  <Box mb={2}>
                    <Typography variant="subtitle2">
                      ¿En qué fecha ocurrió? *
                    </Typography>
                    <KeyboardDatePicker
                      style={{ backgroundColor: 'white' }}
                      disableToolbar
                      disableFuture
                      variant="inline"
                      inputVariant="outlined"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="date-picker"
                      value={selectedDate}
                      onChange={handleDateChange}
                      maxDate={maxDate}
                      minDate={minDate()}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      keyboardIcon={<CalendarIcon />}
                      invalidLabel={'Formato de fecha inválido'}
                      invalidDateMessage={'Formato de fecha inválido'}
                      InputProps={{ readOnly: true }}
                      helperText={
                        'Podés modificar seleccionando el ícono de la fecha'
                      }
                      fullWidth
                    />
                  </Box>
                  <Box mb={2}>
                    <Typography variant="subtitle2">¿A qué hora? *</Typography>
                    <KeyboardTimePicker
                      fullWidth={true}
                      inputVariant="outlined"
                      margin="normal"
                      id="time-picker"
                      ampm
                      value={selectedDate}
                      onChange={handleDateChange}
                      KeyboardButtonProps={{
                        'aria-label': 'change time',
                      }}
                      cancelLabel="Cancelar"
                      keyboardIcon={<TimeIcon />}
                      invalidLabel={'Formato de hora inválido'}
                      invalidDateMessage={'Formato de hora inválido'}
                      InputProps={{ readOnly: true }}
                      helperText={
                        'Podés modificar seleccionando el ícono de la hora'
                      }
                    />
                  </Box>
                </Grid>
              </MuiPickersUtilsProvider>
            </Box>
          </Box>
          <Box my={4}>
            <FloatingButton onClick={callNextStep} disabled={!selectedDate}>
              Continuar
            </FloatingButton>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default SelectDate;
